import { useNavigate } from 'react-router-dom';
import { Home, ArrowLeft, FileQuestion, BookOpen, Settings, BarChart3, FileText, Zap } from 'lucide-react';

export function NotFound() {
  const navigate = useNavigate();

  const quickLinks = [
    { icon: FileQuestion, label: 'Question Bank', path: '/questions' },
    { icon: Zap, label: 'Generate Questions', path: '/generator-center' },
    { icon: BookOpen, label: 'Materials', path: '/materials' },
    { icon: FileText, label: 'Exams', path: '/exams' },
    { icon: BarChart3, label: 'Analytics', path: '/analytics' },
    { icon: Settings, label: 'Settings', path: '/settings/system' },
  ];

  return (
    <div className="min-h-screen bg-gray-50 flex items-center justify-center px-4 py-12">
      <div className="max-w-3xl w-full">
        {/* Main Content */}
        <div className="text-center mb-12">
          {/* 404 Text */}
          <div className="mb-8">
            <h1 className="text-9xl font-bold text-gray-300 mb-4">404</h1>
            <div className="w-24 h-1 bg-blue-600 mx-auto rounded-full mb-6"></div>
          </div>

          {/* Message */}
          <div className="mb-10">
            <h2 className="text-3xl font-bold text-gray-900 mb-3">
              Page Not Found
            </h2>
            <p className="text-lg text-gray-600 max-w-md mx-auto">
              The page you're looking for doesn't exist or has been moved.
            </p>
          </div>

          {/* Action Buttons */}
          <div className="flex flex-col sm:flex-row gap-3 justify-center items-center mb-12">
            <button
              onClick={() => navigate(-1)}
              className="inline-flex items-center gap-2 px-6 py-3 bg-white border border-gray-300 text-gray-700 font-medium rounded-lg hover:bg-gray-50 transition-colors"
            >
              <ArrowLeft className="w-5 h-5" />
              Go Back
            </button>

            <button
              onClick={() => navigate('/dashboard')}
              className="inline-flex items-center gap-2 px-6 py-3 bg-blue-600 text-white font-medium rounded-lg hover:bg-blue-700 transition-colors"
            >
              <Home className="w-5 h-5" />
              Go to Dashboard
            </button>
          </div>
        </div>

        {/* Quick Navigation */}
        <div className="bg-white rounded-lg shadow-sm border border-gray-200 p-6">
          <div className="mb-6">
            <h3 className="text-lg font-semibold text-gray-900 mb-1">
              Quick Navigation
            </h3>
            <p className="text-sm text-gray-600">
              Jump to a section
            </p>
          </div>

          <div className="grid grid-cols-2 sm:grid-cols-3 gap-3">
            {quickLinks.map((link) => {
              const Icon = link.icon;
              return (
                <button
                  key={link.path}
                  onClick={() => navigate(link.path)}
                  className="flex items-center gap-3 p-4 rounded-lg border border-gray-200 hover:border-blue-400 hover:bg-blue-50 transition-all text-left"
                >
                  <Icon className="w-5 h-5 text-gray-600 flex-shrink-0" />
                  <span className="text-sm font-medium text-gray-700">
                    {link.label}
                  </span>
                </button>
              );
            })}
          </div>
        </div>
      </div>
    </div>
  );
}
